import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '@/shared/constants/linksApi.js'

// Данные Basic Auth
const API_USER = process.env.API_USER || 'testuser'
const API_PASS = process.env.API_PASS || 'testbtpeel748'
const basicAuth = 'Basic ' + Buffer.from(`${API_USER}:${API_PASS}`).toString('base64')

export const newsApi = createApi({
  reducerPath: 'newsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json')
      headers.set('Authorization', basicAuth)
      return headers
    },
  }),
  endpoints: (builder) => ({
    getNews: builder.mutation({
      query: () => ({
        url: '/back/news/list',
        method: 'POST',
      }),
    }),
    getOtherNews: builder.mutation({
      query: (newsId) => ({
        url: '/back/news/another',
        method: 'POST',
        body: { id: newsId },
      }),
    }),
    getOneNews: builder.mutation({
      query: (newsId) => ({
        url: '/back/news/one',
        method: 'POST',
        body: { id: newsId },
      }),
    }),
  }),
})
